/** @format */

import React from 'react';
import SVG from 'react-inlinesvg';
import { Container, Image, Grid } from 'semantic-ui-react';
import { Informations } from '..';

import './Footer.css';

const Footer = () => (
  <div className="footer" style={{ background: '#ffffff' }}>
    <Container fluid className="footer-container">
      <Grid
        aria-label="Sedi A2A Smart City"
        className="footer-grid"
        columns={6}
        stackable
        relaxed="very"
        verticalAlign="top"
      >
        <Grid.Column>
          <Image
            className="logo-footer"
            src={'/assets/images/logoColor.png'}
            alt="Logo A2A Smart City"
            aria-label="Logo A2A Smart City"
          />
        </Grid.Column>
        <Grid.Column>
          <h5>BERGAMO</h5>
          <div>Via Suardi, 26</div>
        </Grid.Column>
        <Grid.Column>
          <h5>BRESCIA</h5>
          <div>Via A. Lamarmora, 230</div>
        </Grid.Column>
        <Grid.Column>
          <h5>CREMONA</h5>
          <div>Via dell’Innovazione Digitale, 8</div>
        </Grid.Column>
        <Grid.Column>
          <h5>MILANO</h5>
          <div>Via Olgettina, 25</div>
        </Grid.Column>
        <Grid.Column>
          <h5>CONTACTS</h5>
          <div style={{ marginBottom: '5px' }}>
            <a href="mailto:info@a2asmartcity.it" tabIndex={0}>
              info@a2asmartcity.it
            </a>
          </div>
          <div>
            <a href="https://www.a2asmartcity.it/contatti/" tabIndex={0}>
              www.a2asmartcity.it
            </a>
          </div>
        </Grid.Column>
      </Grid>

      <div className="footer-icons">
        <a
          href="https://twitter.com/A2ASmartCity"
          aria-label="Twitter A2A Smart City"
          className="footer-touch-target"
          tabIndex={0}
        >
          <SVG src="/assets/images/X.svg" />
        </a>
        <a
          href="https://www.linkedin.com/showcase/a2a-smart-city/"
          aria-label="LinkedIn A2A Smart City"
          className="footer-touch-target"
          tabIndex={0}
        >
          <SVG src="/assets/images/linkedin.svg" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCHczlhVciqpwLdUweQTJXJQ"
          aria-label="YouTube A2A Smart City"
          className="footer-touch-target"
          tabIndex={0}
        >
          <SVG src="/assets/images/youtube.svg" />
        </a>
        <a
          href="mailto:info@a2asmartcity.it"
          aria-label="Email A2A Smart City"
          className="footer-touch-target"
          tabIndex={0}
        >
          <SVG src="/assets/images/email.svg" />
        </a>
      </div>
      <>
        <div className="copyright">
          <span>
            <small>
              <div>Copyright ©2025 A2A Smart city</div>
              <div>
                P.I. 02159020177 - www.a2asmartcity.it <Informations /> -{' '}
                <a href="/assets/documents/Dichiarazione_Accessibilita.pdf" download>
                  Dichiarazione di accessibilità
                </a>
              </div>
            </small>
          </span>
        </div>
      </>
    </Container>
  </div>
);

export { Footer };
